module.exports = __webpack_public_path__ + "static/q2-bbd58c971ed436a589d9d7f31ff8f8c2.svg";